import useIPA from '@/auth/jwt/useJwt'
import router from '@/router/index.js'

// initial state
const state = () => ({
  perPage: 10,
  pageOptions: [10, 20, 50],
  totalRows: 1,
  sortOptions: [],
  options: [],
  fields: [
    { key: 'name', label: 'Name', sortable: true },
    { key: 'prefix', label: 'Prefix' },
    { key: 'partner_name', label: 'Partner Name' },
    { key: 'logo', label: 'Logo' },
    { key: 'address', label: 'Address' },
    { key: 'created_at', label: 'Created At' },
    { key: 'status', label: 'Status', sortable: true },
    { key: 'action', label: 'Action' },
  ],
  items: [],
})

// getters
const getters = {}

// actions
const actions = {
  getAll({ commit }, params) {
    const param = { status: 'master/companies', params }
    useIPA.get(param).then(response => {
      const company = {
        rows: response.data.data,
      }
      const { pagination } = response.data
      commit('setData', { ...company })
      commit('setPagination', pagination)
    })
  },
  getById({ commit }, id) {
    return new Promise((resolve, reject) => {
      const param = { status: `master/company/${id}` }
      useIPA.get(param).then(response => {
        resolve(response.data.data)
      })
    })
  },
  formPostPut({ commit }, formData) {
    return new Promise((resolve, reject) => {
      const rawData = new FormData()
      rawData.set('partner_id', parseInt(formData.select_1))
      rawData.set('prefix', formData.text_1)
      rawData.set('name', formData.text_2)
      rawData.set('address', formData.text_3)
      if (formData.setImage === 'upload') {
        rawData.append('logo', formData.logo)
      } else {
        rawData.set('logo', formData.logo)
      }
      const param = { rawData, url: 'internal/master/company', id: formData.id }
      useIPA.postput(param)
        .then(response => {
          router.push({ name: 'company' })
          if (response.data.hasErrors) {
            reject(response.data.message)
          } else {
            resolve(response.data)
          }
        },
        error => {
          if (error.response.data.hasOwnProperty('hasErrors')) {
            reject(error.response.data.message)
          } else {
            reject(error.message)
          }
        })
    })
  },
  remove({ commit }, id) {
    return new Promise((resolve, reject) => {
      const param = { url: 'internal/master/company', id }
      useIPA.delete(param)
        .then(response => {
          if (response.data.hasErrors) {
            reject(response.data.message)
          } else {
            resolve(response.data)
          }
        },
        error => {
          if (error.response.data.hasOwnProperty('hasErrors')) {
            reject(error.response.data.message)
          } else {
            reject(error.message)
          }
        })
    })
  },
}

// mutations
const mutations = {
  setData(state, company) {
    state.items = company.rows
    state.totalRows = company.rows.length
    state.options = []
    for (let i = 0; i < company.rows.length; i++) {
      const option = []
      for (const key in company.rows[i]) {
        if (key === 'id') {
          option.value = company.rows[i][key]
        } else if (key === 'name') {
          option.title = company.rows[i][key]
        } else if (key === 'id') {
          option.oid = company.rows[i][key]
        }
      }
      state.options.push({ ...option })
    }
  },
  setPagination(state, pagination) {
    state.perPage = pagination.limit
    state.totalRows = pagination.total_items
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
